<template>
    <div>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="body-2 my-6 text-left">
            {{
                $gettext('For allowing the app(s), please double click an app or drag them to your device on the left')
            }}
        </div>
        <div v-else class="body-2 my-6 text-left">
            {{
                $gettext('For allowing the app, please tap twice')
            }}
        </div>
        <v-card class="mt-2 mb-16 pa-3 overflow-y-auto" elevation="10" rounded>

            <app-store-header
                @update:chosenAppSource="val => chosenAppSource = val"
                @update:appFilterStoreText="val => appFilterStoreText = val "
            ></app-store-header>

            <v-divider class="mb-3"></v-divider>
            <app-store-messages :appFilterStoreText="appFilterStoreText" :hasApp="hasApp"></app-store-messages>

            <!--                                                    <draggable v-model="chosenAppSource === 'common' ?
                                                                 appsCommon.applications['all applications'] : phoneTypes[phoneTypeIndex]['value']['applications']['all applications']"-->

            <!--                       @clone="refreshAppStoreApps()"-->
            <draggable v-if="hasApp"
                       :group="{ name: 'apps', pull: 'clone', put: false }"
                       :list="filteredCurrentAppsForStore"
                       :options="{disabled : $vuetify.breakpoint.smAndDown}"
                       class="app-grid-right"
                       handle=".dragHandle"
                       @clone="(evt) => handleAppDraggedFromStore(evt)"
            >

                <!-- class="cursor-move"    -->
                <!--                @openAddEditAppDialog="(val) => openAddEditAppDialog(val)"-->

                <template v-for="app in filteredCurrentAppsForStore">
                    <app-icon
                        v-if="showAppIfNotInstalledAlready(app.packageId)"
                        :key="app.packageId"
                        :id="app.packageId"
                        :app-name="app['appName']"
                        :device-name="chosenModel"
                        :folder-name="getPhoneTypeDirForDevice(chosenModel, true, chosenAppSource)"
                        :isAppsSourceDevice="true"
                        :package-name="app.packageId"
                        :showMenu="showMenu"
                        :x="x"
                        :y="y"
                        class="mb-3 mt-2 cursor-move"
                        @changeShowMenu="(val) => updateShowMenu(val, app.packageId)"
                        @installApp="installApp"
                    />
                </template>
            </draggable>

        </v-card>
    </div>
</template>


<script>
// import Vue from 'vue'
// import { reactive, ref, onMounted } from '@vue/composition-api'
import draggable from 'vuedraggable'
import {computed, onMounted, ref, toRef, watch, onUnmounted} from "vue";
import DeviceSearchingText from "@/components/blocks/DeviceSearchingText.vue";
import DeviceNoAppsFound from "@/components/blocks/DeviceNoAppsFound.vue";
import AppIcon from "@/components/devices/AppIcon.vue";
import {storeToRefs} from "pinia";
import {usePhonesStore} from "@/stores/PhonesStore";
import Snackbar from "@/components/Snackbar.vue";
import {usePhoneTypesStore} from "@/stores/PhoneTypesStore";
import {getPhoneTypeDirForDevice} from "@/composables/getPhoneTypeDirForDevice";
import {findIndex, isInteger} from "lodash";
import AppStoreHeader from "@/components/devices/AppStoreHeader.vue";
import AppStoreMessages from "@/components/devices/AppStoreMessages.vue";
import {eventBus} from "@/main";

export default {
    name: 'AppStore',
    components: {
        AppStoreMessages,
        AppStoreHeader,
        DeviceNoAppsFound,
        DeviceSearchingText,
        Snackbar,
        AppIcon,
        draggable
    },
    setup(props, context) {

        let appFilterStoreText = ref('');
        let chosenAppSource = ref('system');
        let showMenu = ref({value: false, packageName: ''});
        let x = ref(0);
        let y = ref(0);
        let filteredCurrentAppsForStore = ref([]);

        // required prop chosenModel
        /*const chosenModel = toRef(props, 'chosenModel')
        chosenModel.value = props.chosenModel*/

        // props


        // const phoneTypeIndex = toRef(props, 'phoneTypeIndex')

        const phonesStore = usePhonesStore()
        const {
            configurations,
            currentSelectedConfiguration,
            currentSelectedConfigurationIndex,
            chosenModel,
        } = storeToRefs(phonesStore);


        const phoneTypesStore = usePhoneTypesStore()
        const {
            phoneTypes,
            appsCommon,
            phoneTypeIndex,
        } = storeToRefs(phoneTypesStore);


        function getAppsAsPerChosenSource() {

            let apps;
            // Always show system apps (installed_applications) 
            // Common apps from server are no longer supported
            // if (chosenAppSource.value === 'common') {
            //     apps = appsCommon.value.applications['all applications']
            // } else {

                apps = configurations.value[currentSelectedConfigurationIndex.value].value['installed_applications']

                /*
                if (phoneTypeIndex?.value > -1) {
                    apps = phoneTypes.value[phoneTypeIndex.value]['value']['applications']['all applications']
                }
                */

            // }

            return apps;

        }

        let removeDuplicatePackageForCurrentConfiguration = function (packageId, appName, newIndex = false) {

            let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
            let firstOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId))

            if (firstOccurrenceIndex > -1) {

                let secondOccurrenceIndex = findIndex(applications, (application, index) => (application.packageId === packageId), firstOccurrenceIndex + 1)

                if (secondOccurrenceIndex > -1 && isInteger(newIndex) && newIndex > -1) {
                    applications.splice(newIndex, 1)
                    // self.$refs.snackbar.showSnackbar(self.$gettext(appName + ' is already installed for the device ' + self.chosenModel), 'info')
                }

            }

        }

        function filteredCurrentApplicationsForStore() {

            let appsAsPerChosenSource = getAppsAsPerChosenSource();

            let currentInstalledApplications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;

            if (currentInstalledApplications.length > 0) {
                appsAsPerChosenSource = appsAsPerChosenSource?.filter((application) => {
                    return !currentInstalledApplications.some((app) => app.packageId === application.packageId)
                })
            }

            if (appFilterStoreText.value.length > 0) {
                appsAsPerChosenSource = appsAsPerChosenSource?.filter((application) => {
                    return application.appName.toLowerCase().includes(appFilterStoreText.value.toLowerCase())
                })
            }

            return appsAsPerChosenSource;

        }

        filteredCurrentAppsForStore.value = filteredCurrentApplicationsForStore();

        let hasApp = computed(() => {

            let filteredApps = filteredCurrentAppsForStore.value;

            if (filteredApps?.length > 0) {
                return true;
            }

            return false;

        });

        let updateShowMenu = function (val, packageName) {

            // TODO: This if is no help, remove it.
            if (val.packageName === packageName) {

                self.$set(showMenu, 'value', val.value)
                self.$set(showMenu, 'packageName', val.packageName)

                x = val.x
                y = val.y

            }

        }

        /*let installApp = function (packageId) {

            let appStoreApps = getAppsAsPerChosenSource();
            let appToBeInstalled = appStoreApps.filter((application) => application.packageId.toLowerCase().includes(packageId.toLowerCase()))

            if (appToBeInstalled?.length > 0) {
                let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
                applications.splice(0, 0, appToBeInstalled[0])
                removeDuplicatePackageForCurrentConfiguration(appToBeInstalled[0].packageId, appToBeInstalled[0].appName, 0)
            }

            // eventBus emit event to update the app list on the left side
            eventBus.$emit('update-app-list', currentSelectedConfiguration.value)
            refreshAppStoreApps()
        }*/

        let installApp = function (packageId) {
            let appStoreApps = getAppsAsPerChosenSource();
            let appToBeInstalled = appStoreApps.filter((application) =>
                application.packageId.toLowerCase().includes(packageId.toLowerCase())
            );

            if (appToBeInstalled?.length > 0) {

                let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
                applications.splice(0, 0, appToBeInstalled[0]);
                removeDuplicatePackageForCurrentConfiguration(appToBeInstalled[0].packageId, appToBeInstalled[0].appName, 0);

                /*
                let availableApps = configurations.value[currentSelectedConfigurationIndex.value].value.installed_applications;
                const appIndex = findIndex(availableApps, application => application.packageId === packageId);

                if (appIndex > -1) {
                    availableApps.splice(appIndex, 1);
                }
                 */
            }

            eventBus.$emit('update-app-list', currentSelectedConfiguration.value);
            refreshAppStoreApps();
        }

        let refreshLeftDeviceAppList = function () {
            eventBus.$emit('update-app-list', currentSelectedConfiguration.value)
        }

        let refreshAppStoreApps = function () {
            filteredCurrentAppsForStore.value = filteredCurrentApplicationsForStore();
        }

        let showAppIfNotInstalledAlready = function (packageId) {

            let applications = configurations.value[currentSelectedConfigurationIndex.value].value.applications;
            let appAlreadyInstalled = applications.some((app) => app.packageId === packageId)

            if (appAlreadyInstalled) {
                return false;
            }

            return true;

        }

        function handleAppDraggedFromStore(evt) {
            refreshAppStoreApps();
        }

        eventBus.$on('app-deleted', (packageId) => {
            refreshAppStoreApps()
        })

        watch(chosenAppSource, (val) => {
            refreshAppStoreApps()
        })
        watch(appFilterStoreText, (val) => {
            refreshAppStoreApps()
        })
        watch(currentSelectedConfiguration, (val) => {
            refreshAppStoreApps()
        })

        onMounted(() => {
            eventBus.$on('refresh-app-store', refreshAppStoreApps);
        });
        onUnmounted(() => {
            eventBus.$off('refresh-app-store', refreshAppStoreApps);
        });

        return {
            appFilterStoreText,
            phoneTypes,
            phoneTypeIndex,
            configurations,
            currentSelectedConfiguration,
            currentSelectedConfigurationIndex,
            chosenModel,
            chosenAppSource,
            showMenu,
            getPhoneTypeDirForDevice,
            x,
            y,
            updateShowMenu,
            appsCommon,
            installApp,
            removeDuplicatePackageForCurrentConfiguration,
            hasApp,
            refreshLeftDeviceAppList,
            filteredCurrentAppsForStore,
            refreshAppStoreApps,
            showAppIfNotInstalledAlready,
            handleAppDraggedFromStore
        }
    },
}
</script>
<style scoped type="text/scss">
.app-grid-right {
    display: grid;
    /* grid-template-columns: repeat(5, 1fr); grid-column-gap: 40px; grid-row-gap: 10px; */
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));

    /* grid-template-rows: repeat(3, 1fr); grid-template-rows: repeat(6, 1fr); row-gap: 20px; column-gap: 10px; */


}
</style>
